import { call, put, select, takeLatest } from "redux-saga/effects";
import { loadApplicationData } from "../../../services/coilConfiguratorApi";
import type { RootState } from "../../appState";
import {
  hydrateAssumptions,
  hydrateCatalogue,
  hydrateConfigurations,
  hydrateGlossary,
  hydrateMeasurements,
  showToast,
} from "../actions";
import {
  LOAD_APPLICATION_STATE,
  LOAD_APPLICATION_STATE_FAILURE,
  LOAD_APPLICATION_STATE_SUCCESS,
} from "../types";

function* loadApplicationStateSaga(): Generator {
  try {
    const data: Awaited<ReturnType<typeof loadApplicationData>> = yield call(loadApplicationData);
    yield put(hydrateCatalogue(data.catalogue));
    yield put(hydrateAssumptions(data.assumptions));
    yield put(hydrateConfigurations(data.configurations));
    yield put(hydrateMeasurements(data.measurements));
    yield put(hydrateGlossary(data.glossary));
    yield put({
      type: LOAD_APPLICATION_STATE_SUCCESS,
      updatedAt: new Date().toISOString(),
    });
  } catch (error) {
    const message = error instanceof Error ? error.message : "Failed to load application data";
    yield put({ type: LOAD_APPLICATION_STATE_FAILURE, error: message });
    yield put(showToast(message, "error"));
  }
}

function* persistenceWatcher(): Generator {
  yield takeLatest(LOAD_APPLICATION_STATE, loadApplicationStateSaga);
}

export default persistenceWatcher;
